import { AsgardFeatureNames } from 'src/models/AsgardFeatures';

export interface IRequiredEventArgs {
    required: boolean;
    raise(...args: any): Promise<boolean> | boolean;
}

export enum ChainSenders {
    UI = 'UI',
    PDF_DOCUMENT = 'PDF_DOCUMENT',
    HTML_DOCUMENT = 'HTML_DOCUMENT',
}


export interface ValidatorsArgs {
    paneIndex: number | null;
    feature: AsgardFeatureNames | null;
    args: any;
    documentId: string | null;
    event: any;
}




